import React, { useEffect, useState } from 'react';
import { View, TouchableOpacity, Image, Text, useWindowDimensions, StyleSheet } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { callApi, getUserId } from '../Helper/Helper';
import notificationImg from '../../image/notification.png';
import askhelpImg from '../../image/askhelp.png';
import foodserviceImg from '../../image/foodservice.png';
import householdImg from '../../image/household.png';
import transportImg from '../../image/transport.png';
import threebarsImg from '../../image/threebars.png';

    const NotificationIcon = ({ userId, iconSize, styles, navigation }) => {
      const [unreadCount, setUnreadCount] = useState(0);

      const checkNotifications = async () => {
        if (!userId) return;
        try {
          // Simplified: Call the aggregate offer endpoints for this user
          const categories = ['offer-eat', 'offer-live', 'offer-move'];

          // Fetch counts from each category for the user
          // Endpoints follow: /offer-type/{userId}/NA (NA as placeholder for itemId if fetching all)
          const offerFetches = categories.map(endpoint =>
            callApi('GET', `${endpoint}/${encodeURIComponent(userId)}/NA`)
              .then(r => (r?.Items?.length || (Array.isArray(r) ? r.length : 0)))
              .catch(() => 0)
          );

          const counts = await Promise.all(offerFetches);
          const totalOffers = counts.reduce((acc, curr) => acc + curr, 0);

          // Compare with last seen count in storage
          const lastSeenStr = await AsyncStorage.getItem(`last_seen_offers_${userId}`);
          const lastSeen = parseInt(lastSeenStr || '0', 10);

          if (totalOffers > lastSeen) {
            setUnreadCount(totalOffers - lastSeen);
          } else {
            setUnreadCount(0);
          }
        } catch (e) {
          console.warn('Notification check failed', e);
        }
      };

      useEffect(() => {
        checkNotifications();
        // Updated to 5 minutes (300,000 ms)
        const interval = setInterval(checkNotifications, 60000);
        return () => clearInterval(interval);
      }, );

          const handlePress = async () => {
            try {
              // 1. Fetch current total count to mark them all as "seen"
              const categories = ['offer-eat', 'offer-live', 'offer-move'];
              const offerFetches = categories.map(endpoint =>
                callApi('GET', `${endpoint}/${encodeURIComponent(userId)}/NA`)
                  .then(r => (r?.Items?.length || (Array.isArray(r) ? r.length : 0)))
                  .catch(() => 0)
              );

              const counts = await Promise.all(offerFetches);
              const totalOffers = counts.reduce((acc, curr) => acc + curr, 0);

              // 2. Update storage so the next check knows we've seen these
              await AsyncStorage.setItem(`last_seen_offers_${userId}`, String(totalOffers));

              // 3. Reset local state to hide the badge immediately
              setUnreadCount(0);
            } catch (e) {
              console.warn('Failed to reset notification count', e);
            }

            // 4. Navigate to the MyAsks screen
            navigation.navigate('AllMyAsks');
          };

          return (
        <TouchableOpacity
      style={[styles.footerItem, { flex: 1, alignItems: 'center' }]}
      onPress={handlePress}>
      <View>
        <Image
          source={notificationImg} // Ensure this image exists
          style={[styles.footerIcon, { width: iconSize, height: iconSize }]}
        />
        {unreadCount > 0 && (
          <View style={localStyles.badge}>

            <Text style={localStyles.badgeText}>{unreadCount > 9 ? '9+' : unreadCount}</Text>
          </View>
        )}
      </View>
      <Text style={styles.footerText}>All My Asks</Text>
    </TouchableOpacity>
  );
};

const ConsumerSection = ({ navigation, setModalVisible, setMenuVisible, styles }) => {
  const { width } = useWindowDimensions();
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    getUserId().then(setUserId);
  }, []);

  // Scale icon size with screen width, with sensible min/max bounds
  const iconSize = Math.max(28, Math.min(48, Math.round(width * 0.1)));

  // Full-width row with evenly distributed items
  const rowPadding = Math.max(8, Math.min(20, Math.round(width * 0.03)));
  const footerRowStyle = [
    styles.footerScrollContent,
    {
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: rowPadding,
    },
  ];

  const footerItemFullWidthStyle = [styles.footerItem, { flex: 1, alignItems: 'center' }];

      return (
        <View style={styles.footerContainer}>
          <View style={footerRowStyle}>
            <TouchableOpacity
              style={footerItemFullWidthStyle}
              onPress={() => navigation.navigate('ConsumerPostNeed')}>
              <Image
                source={askhelpImg}
                style={[styles.footerIcon, { width: iconSize, height: iconSize }]}
              />
              <Text style={styles.footerText}>Ask</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={footerItemFullWidthStyle}
              onPress={() => navigation.navigate('ConsumerGetEatFromProvider')}>
              <Image
                source={foodserviceImg}
                style={[styles.footerIcon, { width: iconSize, height: iconSize }]}
              />
              <Text style={styles.footerText}>Food</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={footerItemFullWidthStyle}
              onPress={() => navigation.navigate('ConsumerGetLiveFromProvider')}>
              <Image
                source={householdImg}
                style={[styles.footerIcon, { width: iconSize, height: iconSize }]}
              />
              <Text style={styles.footerText}>Household</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={footerItemFullWidthStyle}
              onPress={() => navigation.navigate('ConsumerGetMoveFromProvider')}>
              <Image
                source={transportImg}
                style={[styles.footerIcon, { width: iconSize, height: iconSize }]}
              />
              <Text style={styles.footerText}>Transport</Text>
            </TouchableOpacity>

            <NotificationIcon
              userId={userId}
              iconSize={iconSize}
              styles={styles}
              navigation={navigation}
            />

            <TouchableOpacity
              style={footerItemFullWidthStyle}
              onPress={() => setMenuVisible(true)}>
              <Image
                source={threebarsImg}
                style={[styles.footerIcon, { width: iconSize, height: iconSize }]}
              />
              <Text style={styles.footerText}>Menu</Text>
            </TouchableOpacity>
          </View>
        </View>
      );
    };

const localStyles = StyleSheet.create({
  badge: {
    position: 'absolute',
    right: -6,
    top: -3,
    backgroundColor: '#FF3B30',
    borderRadius: 10,
    width: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1.5,
    borderColor: '#fff',
  },
  badgeText: {
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold',
  },
});

export default ConsumerSection;
